<template>
    <div>

        <!--Start Middle content-->

        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Wellness 
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="locationId"
                                          name="locationId"
                                          id="locationData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select State">
                                </v-select>
                            </div>
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="roleId"
                                          name="roleId"
                                          id="roleData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="roleArr"
                                          placeholder="Select Role">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->

        <div class="internal-page-main-section wellness-section-main col-12">
            <div class="container">
                <div class="row">
                    <app-slider :sliderType='sliderType' :key='sliderType.location_type'></app-slider>
                    <template v-for="(wellness, index) in wellnessData">
                        <div :id="'wellness_' + wellness.id" class="wellness-main-section-h col-12 float-l">
                            <div class="row">
                                <div class="wellness-left-section col-12 col-sm-7 col-md-7 col-lg-7 float-l">
                                    <div class="row">
                                        <div class="wellness-right-img-box">
                                            <div class="wellness-left-text-box">
                                                <h2> <template v-if="wellness.title !=''">{{wellness.title}}</template> <span v-if="wellness.second_title !=''"> {{wellness.second_title}} </span> </h2>
                                                <p v-if="wellness.tag_line !=''"> {{wellness.tag_line}} </p>
                                                <div class="view-btn-small-red btn-pd-top col-12">
                                                    <!--<div class="row">-->
                                                        <!-- <a v-if="wellness.flyer !=''" :href="wellness.flyer" target="_blank" class="hvr-sweep-to-right-red ucase"> View Flyer </a> -->
                                                        <a v-if="wellness.flyer !=''" href="#" :id="'id' + index" @click="getSignedUrlPath(wellness.flyer)" class="hvr-sweep-to-right-red ucase"> View Flyer </a>
                                                    <!--</div>-->
                                                </div>
                                            </div>
                                            <template v-if="wellness.image_link != ''">
                                                <a :href="wellness.image_link" target="_blank">
                                                    <img v-if="wellness.image !=''" :src="wellness.image" :alt="wellness.title">
                                                </a>
                                            </template>
                                            <template v-else>
                                                <img v-if="wellness.image !=''" :src="wellness.image" :alt="wellness.title">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="wellness-right-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                    <div class="row">
                                        <h3 v-if="wellness.description_title != ''" class="color-blue heading-text-24 line-height-28 font-text-bold-mont"> {{wellness.description_title}} </h3>
                                        <p v-html="wellness.description" v-if="wellness.description != ''" class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-40 right-top-wellness-text"></p>
                                        <div v-if="wellness.website_link !=''" class="view-btn-small-big mt-45 col-12">
                                            <div class="row">
                                                <a :href="wellness.website_link" target="_blank" class="hvr-sweep-to-right-blue ucase"> Visit Website </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!--<div class="wellness-main-section-h col-12 float-l">
                        <div class="row">
                            <div class="wellness-left-section col-12 col-sm-7 col-md-7 col-lg-7 float-l">
                                <div class="row">
                                    <div class="wellness-right-img-box">
                                        <div class="wellness-left-text-box">
                                            <h2> Accessible Aetna <span> Get Active Program </span> </h2>
                                            <P> View Touchdown Flyer  </P>
                                            <div class="view-btn-small-red btn-pd-top col-12">
                                                <div class="row">
                                                    <a href="/static/pdf/tA_16160_november_flyer_9_13_17.pdf" target="_blank" class="hvr-sweep-to-right-red ucase"> View Flyer </a>
                                                </div>
                                            </div>
                                        </div>
                                        <img src="/static/images/football-bg-img.jpg" alt="Healthy Selfie">
                                    </div>
                                </div>
                            </div>  
                            <div class="wellness-right-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                <div class="row">
                                    <p class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-40 right-top-wellness-text">It’s football season! Are you ready for action-packed games, commercials and great food? Whether you’re tailgating or throwing a party at home, you can still indulge in your game-day favorites. </p>
                                    <p class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-30 right-bottom-wellness-text"> Aetna is the brand name used for products and services provided by one or more of the Aetna group of
                                        subsidiary companies, including Aetna Life Insurance Company and its affiliates (Aetna).  </p>
                                </div>
                            </div>           
                        </div>
                    </div>
                    <div class="wellness-main-section-h col-12 float-l">
                        <div class="row">
                            <div class="wellness-left-section col-12 col-sm-7 col-md-7 col-lg-7 float-l">
                                <div class="row">
                                    <div class="wellness-right-img-box">
                                        <div class="wellness-left-text-box">
                                            <h2> World Diabetes <span> Awareness Day </span> </h2>
                                            <P> World Diabetes Day (WDD) was created in 1991 by IDF and the WHO. </P>
                                            <div class="view-btn-small-red btn-pd-top col-12">
                                                <div class="row">
                                                    <a href="https://www.worlddiabetesday.org/about-wdd.html" target="_blank" class="hvr-sweep-to-right-red ucase"> Visit Website </a>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="https://youtu.be/vk7l5i9AQIo" target="_blank"> <img src="/static/images/vide-bg-wellness.jpg" alt="Healthy Selfie"> </a>
                                    </div>
                                </div>
                            </div>  
                            <div class="wellness-right-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                <div class="row">
                                    <h3 class="color-blue heading-text-24 line-height-28 font-text-bold-mont"> International Diabetes Federation </h3>
                                    <p class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-40 right-top-wellness-text">The primary aim of the World Diabetes Day and World Diabetes Month 2018–19 campaign is to raise awareness of the impact that diabetes has on the family and to promote the role of the family in the management, care, prevention and education of the condition. </p>
                                    <p class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-30 right-bottom-wellness-text"> Aetna is the brand name used for products and services provided by one or more of the Aetna group of
                                        subsidiary companies, including Aetna Life Insurance Company and its affiliates (Aetna).  </p>
                                    <div class="view-btn-small-big mt-45 col-12">
                                        <div class="row">
                                            <a href="https://www.worlddiabetesday.org/about-wdd/wdd-2018-19/key-messages.html" target="_blank" class="hvr-sweep-to-right-blue ucase"> Visit Website </a>
                                        </div>
                                    </div>
                                </div>
                            </div>           
                        </div>
                    </div>
                    <div class="wellness-main-section-h col-12 float-l">
                        <div class="row">
                            <div class="wellness-left-section col-12 col-sm-7 col-md-7 col-lg-7 float-l">
                                <div class="row">
                                    <div class="wellness-right-img-box">
                                        <div class="wellness-left-text-box">
                                            <h2> Live Fit <span> For Less </span> </h2>
                                            <P> Special membership rates for Velocity Vehicle  </P>
                                            <div class="view-btn-small-red btn-pd-top col-12">
                                                <div class="row">
                                                    <a href="/static/pdf/24_hr_fitness_prices.pdf" target="_blank" class="hvr-sweep-to-right-red ucase"> View Flyer </a>
                                                </div>
                                            </div>
                                        </div>
                                        <img src="/static/images/live-fitness-img.jpg" alt="Live Fitness">
                                    </div>
                                </div>
                            </div>  
                            <div class="wellness-right-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                <div class="row">
                                    <h3 class="color-blue heading-text-24 line-height-28 font-text-bold-mont"> Special 7-Days Pass </h3>
                                    <p class="color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-40 right-top-wellness-text">Lift your day in every way with special membership rates at 24 Hour Fitness. From free studio classes, to on-demand workouts, to convenient locations near work and home, we make it easy to work in your workouts so you can live your best.</p>
                                </div>
                            </div>           
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import VueFrame from 'vue-frame';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import SliderComponent from "@/components/SliderComponent";
    var self;
    export default {
        name: 'Wellness',
        mixins: [SessioMixin],
        components: {
            'app-slider': SliderComponent,
            'v-select': vSelect,
            'v-frame': VueFrame,
        },
        data() {
            return {
                sliderType: {
                    type: 'wellness',
                },
                FirstLoad: true,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                wellnessData: [],
                wellnessSliderData: [],
                jumpToWellness: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.loadLocations();
            self.loadRole();
            self.loadWellness();
            self.getBuildVersion();
            /*self.loadWellnessSlider();*/
        },
        watch: {
            locationId: function (locationId) {
                self.loadWellness();
            },
            roleId: function (roleId) {
                self.loadWellness();
            }
        },
        methods: {
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            /*var addAll = {text: 'All', value: '0'};
                             self.locationArr.push(addAll);*/
                            $.each(response.data.content, function (i) {
                                /*if (response.data.content[i].value != 0) {*/
                                self.locationArr.push(response.data.content[i]);
                                /*}*/
                            });
                            self.locationId = {text: response.data.content[0].text, value: response.data.content[0].value};
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            var addAll = {text: 'All', value: '0'};
                            //self.roleArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                            self.roleId = addAll;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadWellness: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        role_id: roleId,
                        location_id: locationId,
                    }
                };
                HTTP.get('displaywellness', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.wellnessData = [];
                                setTimeout(function () {
                                    self.wellnessData = response.data.content;
                                }, 100);
                                self.FirstLoad = false;
                                if (segments[2]) {
                                    self.jumpToWellness = segments[2];
                                    setTimeout(function () {
                                        var top = $("#wellness_" + segments[2]).offset().top;
                                        //var left = $("#hr_" + segments[2]).offset().left;
                                        window.scrollTo(0, top);
                                    }, 10);
                                }
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        })
            },

            loadWellnessSlider() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: 0,
                    roleId: self.roleId,
                    locationId: self.locationId,
                };

                HTTP.post("getwellnessslider/" + 0, data, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.wellnessSliderData = [];
                                setTimeout(function () {
                                    self.wellnessSliderData = response.data.content;
                                }, 100);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Wellness.vue